import { useEffect } from "react";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Button from "@material-ui/core/Button";
import axios from "../../utils/Axios/axiosProxy";
import styles from "./UserEntry.module.scss";
import i18n from "../../utils/LanguageSelector/i18n";

const ConfirmAccount = (props) => {
  const { JWT } = props.match.params;

  useEffect(() => {
    axios
      .get(`/api/user/register/${JWT}`, {})
      .then((response) => {
        console.log("CONFIRMATION RESPONSE: ", response.data.statusText);
      })
      .catch((error) => {
        console.log("CONFIRMATION ERROR: ", error.response.data.message);
      });
  }, [JWT]);

  return (
    <div className={styles.UserEntryContainer}>
      <div className={styles.UserEntryContent}>
        <h2 className={styles.UserEntryTitle}>{i18n.t("confirmacc.label")}</h2>
        <div className={`${styles.UserEntryInputs} FlexCenter Column`}>
          <div>
            <h2 className={styles.ConformationMessage}>
              {i18n.t("confirmacc.congrats1")} <br />
              {i18n.t("confirmacc.congrats2")}
            </h2>
          </div>
          <div className={styles.UserEntryButton}>
            <Link to="/signin">
              <Button className="ToreaBay Medium MarginHorizontal">
                {i18n.t("confirmacc.gotosignin")}
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(ConfirmAccount);
